import * as React from "react"
import { ornamentMarkup, type OrnamentKey } from "@/lib/label-canvas/ornaments"
import { cn } from "@/lib/utils"

// An ornament drawn inline as its own <svg>, for the menu previews. The files
// are single colour through `currentColor`, which an <img> cannot recolour,
// so the markup is injected. That is safe here: every SVG is bundled with the
// app (never user-supplied) and test/lib/ornaments_manifest_test.rb keeps them
// free of script, text, images and external references. Decorative: the
// surrounding button carries the ornament's name. SSR-safe (string markup).

export function OrnamentGlyph({
  ornament,
  color,
  className,
}: {
  ornament: OrnamentKey
  /** Palette hex; omit to inherit the CSS `color`. */
  color?: string
  className?: string
}) {
  const markup = React.useMemo(
    () => ornamentMarkup(ornament, { color, width: "100%", height: "100%" }),
    [ornament, color],
  )
  return <span aria-hidden="true" className={cn("studio-glyph", className)} dangerouslySetInnerHTML={{ __html: markup }} />
}
